import React from 'react';
import PropTypes from 'prop-types';

const IconClose = ({ width, height, fill }) => (
    <svg
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill={fill}
    >
        <path d="M25 50C11.193 50 0 38.807 0 25S11.193 0 25 0s25 11.193 25 25-11.193 25-25 25zm10.97-16.074l-8.949-8.948 8.949-8.948-1.922-1.922-8.948 8.949-8.948-8.949-1.922 1.922 8.949 8.948-8.949 8.948 1.922 1.922 8.948-8.949 8.948 8.949 1.922-1.922z" />
    </svg>
);

IconClose.propTypes = {
    fill: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
};

IconClose.defaultProps = {
    fill: '#999999',
    className: '',
    width: 15,
    height: 15,
};

export default IconClose;
